module.exports = __webpack_public_path__ + "img/input_8.ab7ef370.png";